// utils/ingredientUtils.js

/**
 * Parse `ingredients_normalized` (e.g. `{"a","b"}`, `["a","b"]`, or plain comma-separated).
 * Strips `{}` `[]` and `"`, then splits on commas.
 */
const parseNormalizedIngredientList = (value) => {
  if (!value || typeof value !== 'string') {
    return [];
  }
  return value
    .replace(/[{}\[\]"]/g, '')
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
};

/**
 * Ingredient tokens for search filters from `product.ingredientsNormalized` only.
 */
export const getIngredientListForProduct = (product) => {
  if (!product) {
    return [];
  }
  return parseNormalizedIngredientList(product.ingredientsNormalized);
};

/**
 * @param {Object} product - Product with `ingredientsNormalized`
 * @param {Array} excludedIngredients - Array of { name }
 */
export const shouldExcludeProduct = (product, excludedIngredients) => {
  if (!excludedIngredients || excludedIngredients.length === 0) {
    return false;
  }

  const productIngredients = getIngredientListForProduct(product);
  if (productIngredients.length === 0) {
    return false;
  }

  const excludedSet = new Set(excludedIngredients.map(ingredient => ingredient.name));

  return productIngredients.some(ingredient => excludedSet.has(ingredient));
};

/**
 * @param {Object} product - Product with `ingredientsNormalized`
 * @param {Array} includedIngredients - Array of { name }
 */
export const shouldIncludeProduct = (product, includedIngredients) => {
  if (!includedIngredients || includedIngredients.length === 0) {
    return true;
  }

  const productIngredients = getIngredientListForProduct(product);
  if (productIngredients.length === 0) {
    return false;
  }

  const includedSet = new Set(includedIngredients.map(ingredient => ingredient.name));

  return productIngredients.some(ingredient => includedSet.has(ingredient));
};
